
// export const API_URL="http://localhost:4000"
// export const model_URL="http://localhost:5000"
export const model_URL="https://madhi9-jewelry.hf.space"
export const API_URL="https://backend-6her.onrender.com"
// export const clientId="491653773876-g86ovamtg3g4hpcaig0q2fnqt6raqcam.apps.googleusercontent.com";
export const clientId="172377189202-g3u2o5bk96itq05jg7tell0eoo2skp89.apps.googleusercontent.com"
